import { useRef, useState, useContext } from "react";
import { Link } from "react-router-dom";
// @mui
import { alpha, styled } from "@mui/material/styles";
import {
  Box,
  Divider,
  Typography,
  Stack,
  MenuItem,
  Avatar,
  IconButton,
  Button,
  Slide,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import HomeIcon from "@mui/icons-material/Home";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import DehazeIcon from "@mui/icons-material/Dehaze";
import DensityMediumIcon from "@mui/icons-material/DensityMedium";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import MenuIcon from "@mui/icons-material/Menu";
import { Link as Scroll } from "react-scroll";
import { Link as RouterLink } from "react-router-dom";
// components
import MenuPopover from "./MenuPopover";
import { MyButton } from "../../styles/HomeStyles";

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: "Qui Sommes Nous",
    linkTo: "nous",
  },
  {
    label: "Mot du directeur",
    linkTo: "mot_directeur",
  },
  {
    label: "Nos Métiers",
    linkTo: "nos_metiers",
  },
];

export default function NavbarPopover() {
  const anchorRef = useRef(null);

  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          p: 1,
          color: "primary.main",
          ...(open && {
            "&:before": {
              zIndex: 1,
              content: "''",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              position: "absolute",
              bgcolor: (theme) => alpha(theme.palette.grey[500], 0.5),
            },
          }),
        }}
      >
        <MenuIcon sx={{ fontSize: 30 }} />
      </IconButton>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        checked={open}
        sx={{
          p: 0,
          mt: 1.5,
          ml: 0.75,
          color: "primary.main",
          marginTop: "15px",
          "& .MuiMenuItem-root": {
            typography: "body2",
            borderRadius: 0.75,
          },
        }}
      >
        <Divider sx={{ borderStyle: "dashed" }} />

        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <Scroll key={option.label} to={option.linkTo} smooth spy>
              <MenuItem onClick={handleClose}>
                <Typography variant="subtitle2" noWrap>
                  {option.label}
                </Typography>
              </MenuItem>
            </Scroll>
          ))}

          <MyButton
            sx={{ m: 1 }}
            component={RouterLink}
            to="/formulaire"
            variant="contained"
          >
            Nos Services
          </MyButton>
        </Stack>
      </MenuPopover>
    </>
  );
}
